// src/pages/panels/UsersPage.jsx

import React from "react";

const EmailCampaignsPage = () => {
  return (
    <div>
      <h2>Email Settings Management</h2>
      <p>This is the Email page where you can view and manage users.</p>
    </div>
  );
};

export default EmailCampaignsPage;
